<fieldset [formGroup]="docBoxGroup">
    <div class="table-header p-2 g-2 row">
        <div class="d-none d-lg-block col-auto mt-auto">
            <div class="checkbox-container ms-auto me-auto">
                <input
                    type="checkbox"
                    class="form-control"
                    #checkbox
                    id="documents-select-all-checkbox"
                    formControlName="checkbox"
                    (click)="selectAllDocuments.emit()"
                    [attr.aria-label]="'DOCBOX_SELECT_ALL_FILES' | translate"
                />
                <fa-icon
                    *ngIf="docBox.isAllFilesSelected"
                    [icon]="faCheck"
                    size="2x"
                    (click)="checkbox.click()"
                ></fa-icon>
            </div>
        </div>
        <div class="col-12 col-lg" *ngIf="isFilterCriteriaExpanded">
            <div class="row">
                <div
                    class="col-12 col-form-label text-start"
                    translate="DOCBOX_TYPE_LABEL"
                    (click)="sortByField('docType')"
                >
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'docType' && !docBox.sortByField.ascending"
                        [icon]="faSortDown"
                    ></fa-icon>
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'docType' && docBox.sortByField.ascending"
                        [icon]="faSortUp"
                    ></fa-icon>
                </div>
                <div class="col-12">
                    <span class="search-input">
                        <button
                            *ngIf="docBoxGroup.controls.docTypeInputControl.value"
                            class="btn btn-link btn-sm clear-search-button"
                            (click)="clearFilter(filters.docType)"
                            [attr.aria-label]="'DOCBOX_CLEAR_DOCTYPE_FILTER_ARIA_LABEL' | translate"
                        >
                            X
                        </button>
                        <div class="text-input">
                            <input
                                type="text"
                                formControlName="docTypeInputControl"
                                class="search-input"
                                placeholder="Search"
                            />
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg">
            <div class="row">
                <div
                    class="col-12 col-form-label text-start"
                    translate="DOCBOX_TITLE_LABEL"
                    (click)="sortByField('title')"
                >
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'title' && !docBox.sortByField.ascending"
                        [icon]="faSortDown"
                    ></fa-icon>
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'title' && docBox.sortByField.ascending"
                        [icon]="faSortUp"
                    ></fa-icon>
                </div>
                <div class="col-12">
                    <span class="search-input">
                        <button
                            *ngIf="docBoxGroup.controls.titleInputControl.value"
                            class="btn btn-link btn-sm clear-search-button"
                            (click)="clearFilter(filters.title)"
                            [attr.aria-label]="'DOCBOX_CLEAR_TITLE_FILTER_ARIA_LABEL' | translate"
                        >
                            X
                        </button>
                        <div class="text-input">
                            <input
                                type="text"
                                formControlName="titleInputControl"
                                class="search-input"
                                placeholder="Search"
                            />
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg" *ngIf="isFilterCriteriaExpanded">
            <div class="row">
                <div
                    class="col-12 col-form-label text-start"
                    translate="DOCBOX_PRINT_NUMBER_LABEL"
                    (click)="sortByField('printNumber')"
                >
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'printNumber' && !docBox.sortByField.ascending"
                        [icon]="faSortDown"
                    ></fa-icon>
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'printNumber' && docBox.sortByField.ascending"
                        [icon]="faSortUp"
                    ></fa-icon>
                </div>
                <div class="col-12">
                    <span class="search-input">
                        <button
                            *ngIf="docBoxGroup.controls.printNumberInputControl.value"
                            class="btn btn-link btn-sm clear-search-button"
                            (click)="clearFilter(filters.printNumber)"
                            [attr.aria-label]="'DOCBOX_CLEAR_PRINT_NUMBER_FILTER_ARIA_LABEL' | translate"
                        >
                            X
                        </button>
                        <div class="text-input">
                            <input
                                type="text"
                                formControlName="printNumberInputControl"
                                class="search-input"
                                placeholder="Search"
                            />
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg" *ngIf="isFilterCriteriaExpanded">
            <div class="row">
                <div
                    class="col-12 col-form-label text-start"
                    translate="DOCBOX_DATE_LABEL"
                    (click)="sortByField('date')"
                >
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'date' && !docBox.sortByField.ascending"
                        [icon]="faSortDown"
                    ></fa-icon>
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'date' && docBox.sortByField.ascending"
                        [icon]="faSortUp"
                    ></fa-icon>
                </div>
                <div class="col-12">
                    <span class="search-input">
                        <button
                            *ngIf="docBoxGroup.controls.dateInputControl.value"
                            class="btn btn-link btn-sm clear-search-button"
                            (click)="clearFilter(filters.date)"
                            [attr.aria-label]="'DOCBOX_CLEAR_DATE_FILTER_ARIA_LABEL' | translate"
                        >
                            X
                        </button>
                        <div class="text-input">
                            <input
                                type="text"
                                formControlName="dateInputControl"
                                class="search-input"
                                placeholder="Search"
                            />
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg" *ngIf="isFilterCriteriaExpanded">
            <div class="row">
                <div
                    class="col-12 col-form-label text-start"
                    translate="DOCBOX_CREATED_BY_LABEL"
                    (click)="sortByField('createdBy')"
                >
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'createdBy' && !docBox.sortByField.ascending"
                        [icon]="faSortDown"
                    ></fa-icon>
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'createdBy' && docBox.sortByField.ascending"
                        [icon]="faSortUp"
                    ></fa-icon>
                </div>
                <div class="col-12">
                    <span class="search-input">
                        <button
                            *ngIf="docBoxGroup.controls.createdByInputControl.value"
                            class="btn btn-link btn-sm clear-search-button"
                            (click)="clearFilter(filters.createdBy)"
                            [attr.aria-label]="'DOCBOX_CLEAR_CREATED_BY_FILTER_ARIA_LABEL' | translate"
                        >
                            X
                        </button>
                        <div class="text-input">
                            <input
                                type="text"
                                formControlName="createdByInputControl"
                                class="search-input"
                                placeholder="Search"
                            />
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg" *ngIf="isFilterCriteriaExpanded">
            <div class="row">
                <div
                    class="col-12 col-form-label text-nowrap text-start"
                    translate="DOCBOX_ORDER_NUMBER_LABEL"
                    (click)="sortByField('orderNumber')"
                >
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'orderNumber' && !docBox.sortByField.ascending"
                        [icon]="faSortDown"
                    ></fa-icon>
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'orderNumber' && docBox.sortByField.ascending"
                        [icon]="faSortUp"
                    ></fa-icon>
                </div>
                <div class="col-12">
                    <span class="search-input">
                        <button
                            *ngIf="docBoxGroup.controls.orderNumberInputControl.value"
                            class="btn btn-link btn-sm clear-search-button"
                            (click)="clearFilter(filters.orderNumber)"
                            [attr.aria-label]="'DOCBOX_CLEAR_ORDER_NUMBER_FILTER_ARIA_LABEL' | translate"
                        >
                            X
                        </button>
                        <div class="text-input">
                            <input
                                type="text"
                                formControlName="orderNumberInputControl"
                                class="search-input"
                                placeholder="Search"
                            />
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg" *ngIf="isFilterCriteriaExpanded">
            <div class="row">
                <div
                    class="col-12 col-form-label text-start"
                    translate="DOCBOX_REPORT_STATUS_LABEL"
                    (click)="sortByField('reportStatus')"
                >
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'reportStatus' && !docBox.sortByField.ascending"
                        [icon]="faSortDown"
                    ></fa-icon>
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'reportStatus' && docBox.sortByField.ascending"
                        [icon]="faSortUp"
                    ></fa-icon>
                </div>
                <div class="col-12">
                    <span class="search-input">
                        <button
                            *ngIf="docBoxGroup.controls.reportStatusInputControl.value"
                            class="btn btn-link btn-sm clear-search-button"
                            (click)="clearFilter(filters.reportStatus)"
                            [attr.aria-label]="'DOCBOX_CLEAR_REPORT_STATUS_FILTER_ARIA_LABEL' | translate"
                        >
                            X
                        </button>
                        <div class="text-input">
                            <input
                                type="text"
                                formControlName="reportStatusInputControl"
                                class="search-input"
                                placeholder="Search"
                            />
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg" *ngIf="isFilterCriteriaExpanded">
            <div class="row">
                <div
                    class="col-12 col-form-label text-start"
                    translate="DOCBOX_FILE_TYPE_LABEL"
                    (click)="sortByField('fileType')"
                >
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'fileType' && !docBox.sortByField.ascending"
                        [icon]="faSortDown"
                    ></fa-icon>
                    <fa-icon
                        class="ps-2"
                        *ngIf="docBox.sortByField.field === 'fileType' && docBox.sortByField.ascending"
                        [icon]="faSortUp"
                    ></fa-icon>
                </div>
                <div class="col-12">
                    <span class="search-input">
                        <button
                            *ngIf="docBoxGroup.controls.fileTypeInputControl.value"
                            class="btn btn-link btn-sm clear-search-button"
                            (click)="clearFilter(filters.fileType)"
                            [attr.aria-label]="'DOCBOX_CLEAR_FILE_TYPE_FILTER_ARIA_LABEL' | translate"
                        >
                            X
                        </button>
                        <div class="text-input">
                            <input
                                type="text"
                                formControlName="fileTypeInputControl"
                                class="search-input"
                                placeholder="Search"
                            />
                        </div>
                    </span>
                </div>
            </div>
        </div>
        <div class="d-none d-lg-block col-lg-auto mt-auto text-center" *ngIf="isFilterCriteriaExpanded">
            <button
                class="btn btn-small btn-secondary docbox-upload-new-file"
                (click)="showUploadPopup.emit()"
                [attr.aria-label]="'DOCBOX_UPLOAD_DOCUMENT_TOOLTIP' | translate"
            >
                <fa-icon [icon]="faCloudUploadAlt"></fa-icon>
            </button>
        </div>
        <div class="col-12 text-center py-2" *ngIf="isMobile" (click)="toggleFilterCriteriaExpanded()">
            <a class="btn-link" [translate]="'DOCBOX_FILTERS_SHOW_MORE'" *ngIf="!isFilterCriteriaExpanded"></a>
            <a class="btn-link" [translate]="'DOCBOX_FILTERS_SHOW_LESS'" *ngIf="isFilterCriteriaExpanded"></a>
        </div>
    </div>
</fieldset>
